import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useState } from 'react';
import ElementorBanner from '../Common/ElementorBanner';
import UISpinner from '../../shared/UIComponents/UISpinner';
import ElementorMeetingWarning from './ElementorMeetingWarning';
import useMeetings, { useSelectedMeetingCalendar, } from '../../shared/Meeting/hooks/useMeetings';
import { __ } from '@wordpress/i18n';
import Raven from 'raven-js';
import { BackgroudAppContext, useBackgroundAppContext, } from '../../iframe/useBackgroundApp';
import { refreshToken } from '../../constants/leadinConfig';
import { getOrCreateBackgroundApp } from '../../utils/backgroundAppUtils';
import { isRefreshTokenAvailable } from '../../utils/isRefreshTokenAvailable';
function ElementorMeetingSelect({ url, setAttributes, }) {
    const { mappedMeetings: meetings, loading, error, reload, connectCalendar, } = useMeetings();
    const selectedMeetingCalendar = useSelectedMeetingCalendar(url);
    const [localUrl, setLocalUrl] = useState(url);
    const handleConnectCalendar = () => {
        return connectCalendar()
            .then(() => {
            reload();
        })
            .catch(error => {
            Raven.captureMessage('Unable to connect calendar', {
                extra: { error },
            });
        });
    };
    return (_jsx(Fragment, { children: loading ? (_jsx("div", { children: _jsx(UISpinner, {}) })) : error ? (_jsx(ElementorBanner, { type: "danger", children: __('Please refresh your meetings or try again in a few minutes', 'leadin') })) : (_jsxs(Fragment, { children: [selectedMeetingCalendar && (_jsx(ElementorMeetingWarning, { status: selectedMeetingCalendar, onConnectCalendar: connectCalendar })), meetings.length > 1 && (_jsxs("select", { value: localUrl, onChange: event => {
                        const newUrl = event.target.value;
                        setLocalUrl(newUrl);
                        setAttributes({
                            url: newUrl,
                        });
                    }, children: [_jsx("option", { value: "", disabled: true, selected: true, children: __('Select a meeting', 'leadin') }), meetings.map(item => (_jsx("option", { value: item.value, children: item.label }, item.value)))] }))] })) }));
}
function ElementorMeetingSelectWrapper(props) {
    const isBackgroundAppReady = useBackgroundAppContext();
    return (_jsx(Fragment, { children: !isBackgroundAppReady ? (_jsx("div", { children: _jsx(UISpinner, {}) })) : (_jsx(ElementorMeetingSelect, { ...props })) }));
}
export default function ElementorMeetingsSelectContainer(props) {
    return (_jsx(BackgroudAppContext.Provider, { value: isRefreshTokenAvailable() && getOrCreateBackgroundApp(refreshToken), children: _jsx(ElementorMeetingSelectWrapper, { ...props }) }));
}
